import Modal from './modal'
import Notification from './notification'
import Toast from './toast'
import GlobalFooter from './globalFooter'
import Form from './form'
import Tabs from './tabs'
import Button from './button'
import Row from './row'
import Col from './col'
import Checkbox from './checkbox'
import Alert from './alert'
import Icon from './icon'
import Charts from './charts'
import HeaderSearch from './headerSearch'
import NoticeIcon from './noticeIcon'
import PageHeader from './pageHeader'
import PageHeaderLayout from './pageHeaderLayout'

export {
  Modal,
  Notification,
  Toast,
  GlobalFooter,
  Form,
  Tabs,
  Button,
  Row,
  Col,
  Checkbox,
  Alert,
  Icon,
  Charts,
  HeaderSearch,
  NoticeIcon,
  PageHeader,
  PageHeaderLayout
}



// WEBPACK FOOTER //
// ./src/wbap-components/index.js